import { render, staticRenderFns } from "./WorkingMain.vue?vue&type=template&id=2c49f02f"
import script from "./WorkingMain.vue?vue&type=script&lang=js"
export * from "./WorkingMain.vue?vue&type=script&lang=js"
import style0 from "./WorkingMain.vue?vue&type=style&index=0&id=2c49f02f&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c49f02f')) {
      api.createRecord('2c49f02f', component.options)
    } else {
      api.reload('2c49f02f', component.options)
    }
    module.hot.accept("./WorkingMain.vue?vue&type=template&id=2c49f02f", function () {
      api.rerender('2c49f02f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingMain.vue"
export default component.exports